import { FormControl } from '@angular/forms';
import { OnInit, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { ToastrService } from 'ngx-toastr';
var State = /** @class */ (function () {
    function State(name, population, flag) {
        this.name = name;
        this.population = population;
        this.flag = flag;
    }
    return State;
}());
export { State };
var ComboBoxInputAutocompleteComponent = /** @class */ (function () {
    function ComboBoxInputAutocompleteComponent(toastr) {
        var _this = this;
        this.toastr = toastr;
        this.control = new FormControl();
        this.valueMapper = function (key) {
            if (_this.options !== undefined && _this.options !== null && _this.options.length > 0) {
                var selection = _this.options.find(function (c) { return c.key === key; });
                if (selection) {
                    return selection.value;
                }
            }
        };
        this.required = false;
        this.valorSeleccionado = new EventEmitter();
        this.funcionSeleccionada = new EventEmitter();
        this.valorAutocomplete = new BehaviorSubject('');
    }
    Object.defineProperty(ComboBoxInputAutocompleteComponent.prototype, "options", {
        get: function () {
            return this._options;
        },
        set: function (val) {
            this._options = val;
            this.defineOptions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxInputAutocompleteComponent.prototype, "disableComponent", {
        get: function () {
            return this._disableComponent;
        },
        set: function (val) {
            this._disableComponent = val;
            if (val === undefined || val === null || !val) {
                this.control.enable();
            }
            else {
                this.control.disable();
            }
        },
        enumerable: true,
        configurable: true
    });
    ComboBoxInputAutocompleteComponent.prototype.ngOnInit = function () {
        this.defineOptions();
        if (this.disableComponent !== undefined && this.disableComponent !== null && this.disableComponent) {
            this.control.disable();
        }
    };
    ComboBoxInputAutocompleteComponent.prototype.defineOptions = function () {
        var _this = this;
        this.filteredOptions = this.control.valueChanges.pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    ComboBoxInputAutocompleteComponent.prototype.valueSelected = function (optionSelected) {
        this.valorSeleccionado.emit(optionSelected.value);
    };
    ComboBoxInputAutocompleteComponent.prototype.valueSelectedDirect = function (optionSelected) {
        this.valorSeleccionado.emit(optionSelected);
    };
    ComboBoxInputAutocompleteComponent.prototype.functionPressed = function (functionKey) {
        this.funcionSeleccionada.emit(functionKey);
    };
    ComboBoxInputAutocompleteComponent.prototype._filter = function (option) {
        if (option !== undefined && option !== null && option !== '' && this.options !== undefined && this.options !== null) {
            var filterValue_1 = option.toLowerCase();
            return this.options.filter(function (x) { return x.value.toLowerCase().includes(filterValue_1); });
        }
        else {
            return this.options;
        }
    };
    ComboBoxInputAutocompleteComponent.prototype.isRequired = function () {
        return this.required;
    };
    ComboBoxInputAutocompleteComponent.prototype.isDisabled = function (key) {
        var disabled = false;
        if (this.elementsDisableds !== undefined && this.elementsDisableds !== null && this.elementsDisableds.length > 0) {
            var value = this.elementsDisableds.find(function (x) { return x === key; });
            if (value !== undefined && value !== null) {
                disabled = true;
            }
        }
        return disabled;
    };
    ComboBoxInputAutocompleteComponent.prototype.getColor = function (key) {
        var color = '#000000';
        if (this.colorsKey !== undefined && this.colorsKey !== null) {
            var index = this.colorsKey.findIndex(function (x) { return x.key === key; });
            if (index !== -1) {
                color = this.colorsKey[index].value;
            }
        }
        return color;
    };
    ComboBoxInputAutocompleteComponent.prototype.clickOption = function (key) {
        if (this.isDisabled(key) && this.mensajeDeshabilitado !== undefined && this.mensajeDeshabilitado !== null) {
            this.toastr.warning(this.mensajeDeshabilitado);
        }
        var lowerCaseValue = this.control.value.toLowerCase();
        if (this.options.filter(function (x) { return x.key.toLowerCase().includes(lowerCaseValue); }).length === 1) {
            if (this.control.value !== this.valorAutocomplete.value) {
                var selectedOption = this.options.filter(function (x) { return x.key.toLowerCase().includes(lowerCaseValue); })[0];
                //  this.setValueComb(selectedOption.value);
                this.valueSelectedDirect(selectedOption.key);
            }
        }
    };
    ComboBoxInputAutocompleteComponent.prototype.selectedOption = function (key) {
        var selectedOption;
        if (this.isDisabled(key) && this.mensajeDeshabilitado !== undefined && this.mensajeDeshabilitado !== null) {
            this.toastr.warning(this.mensajeDeshabilitado);
        }
        if (this.options.filter(function (x) { return x.key.toLowerCase().includes(key.toLowerCase()); }).length === 1) {
            selectedOption = this.options.filter(function (x) { return x.key.toLowerCase().includes(key.toLowerCase()); })[0];
            this.valueSelectedDirect(selectedOption.key);
        }
        else if (this.options.filter(function (x) { return x.key.toLowerCase() === key.toLowerCase(); }).length === 1) {
            selectedOption = this.options.filter(function (x) { return x.key.toLowerCase().includes(key.toLowerCase()); })[0];
            this.valueSelectedDirect(selectedOption.key);
        }
    };
    ComboBoxInputAutocompleteComponent.prototype.setValueComb = function (option) {
        if (option !== '') {
            // const filterValue = option.toLowerCase();
            this.control.setValue(option);
            // this.valorAutocomplete = new BehaviorSubject<string>(option);
            this.valorAutocomplete.next(Object.assign(new BehaviorSubject(option)));
            // return this.options.filter(x => x.value.toLowerCase().includes(filterValue));
        } /*else {
          return this.options;
        }*/
    };
    ComboBoxInputAutocompleteComponent.prototype.setValueCombAux = function (option) {
        if (option !== '') {
            // const filterValue = option.toLowerCase();
            this.control.setValue(option);
            this.valorAutocomplete = new BehaviorSubject(option);
            // this.valorAutocomplete.next( Object.assign(new BehaviorSubject<string>(option)));
            // return this.options.filter(x => x.value.toLowerCase().includes(filterValue));
        } /*else {
          return this.options;
        }*/
    };
    ComboBoxInputAutocompleteComponent.prototype.setForcedValueComb = function (option) {
        this.control.setValue(option);
        this.valorAutocomplete = new BehaviorSubject(option);
        // Object.assign(this.valorAutocomplete, new BehaviorSubject<string>(option));
        this.valorAutocomplete.next(option);
        this.control.setValue(option);
        this.control.markAsTouched();
    };
    ComboBoxInputAutocompleteComponent.prototype.checkSelected = function () {
        if (this.control.value !== undefined && this.control.value !== null && this.control.value !== '') {
            var lowerCaseValue_1 = this.control.value.toLowerCase();
            if (this.options.filter(function (x) { return x.value.toString().toLowerCase().includes(lowerCaseValue_1); }).length === 1) {
                if (this.control.value !== this.valorAutocomplete.value) {
                    var selectedOption = this.options.filter(function (x) { return x.value.toLowerCase().includes(lowerCaseValue_1); })[0];
                    this.setValueComb(selectedOption.value);
                    this.valueSelectedDirect(selectedOption.key);
                }
                else {
                }
            }
            else {
                this.resetCombo();
            }
        }
        else {
            this.resetCombo();
            this.valorSeleccionado.emit('');
        }
    };
    ComboBoxInputAutocompleteComponent.prototype.resetCombo = function () {
        this.control.setValue(null);
        this.defineOptions();
    };
    return ComboBoxInputAutocompleteComponent;
}());
export { ComboBoxInputAutocompleteComponent };
